export const DASBHBOARD_BLUE_COLOR = '#3194FD';
export const UnderWritungUser = 'gmcuw';
export var PolicyType;
(function (PolicyType) {
    PolicyType["MARKET_RENEWAL"] = "market_renewal";
    PolicyType["FRESH"] = "fresh";
    PolicyType["STAR_RENEWAL"] = "star_renewal";
})(PolicyType || (PolicyType = {}));
export var FamilyDetailAge;
(function (FamilyDetailAge) {
    FamilyDetailAge["emp"] = "emp";
    FamilyDetailAge["emp18"] = "emp18";
    FamilyDetailAge["emp36"] = "emp36";
    FamilyDetailAge["emp46"] = "emp46";
    FamilyDetailAge["emp56"] = "emp56";
    FamilyDetailAge["mother"] = "mother";
    FamilyDetailAge["spouse"] = "spouse";
    FamilyDetailAge["inlaws"] = "inlaws";
    FamilyDetailAge["child"] = "child";
    FamilyDetailAge["parents"] = "parents";
})(FamilyDetailAge || (FamilyDetailAge = {}));
export var SORTBYLEADS;
(function (SORTBYLEADS) {
    SORTBYLEADS["ASC_DATE"] = "asc_date";
    SORTBYLEADS["DES_DATE"] = "des_date";
})(SORTBYLEADS || (SORTBYLEADS = {}));
export var LeadStatus;
(function (LeadStatus) {
    LeadStatus["DRAFT_SAVED"] = "DRAFT_SAVED";
    LeadStatus["LEAD_GENERATED"] = "LEAD_GENERATED";
    LeadStatus["QUOTE_DOWNLOADED"] = "QUOTE_DOWNLOADED";
    LeadStatus["QUOTE_SHARED"] = "QUOTE_SHARED";
    LeadStatus["PAYMENT_INITIATED"] = "PAYMENT_INITIATED";
    LeadStatus["PAYMENT_DONE"] = "PAYMENT_DONE";
    LeadStatus["QUOTE_FAILED_ICR"] = "QUOTE_FAILED_ICR";
})(LeadStatus || (LeadStatus = {}));
export const PolicyTypeLabel = {
    [PolicyType.MARKET_RENEWAL]: 'Market Renewal',
    [PolicyType.FRESH]: 'Fresh',
    [PolicyType.STAR_RENEWAL]: 'Star Renewal'
};
export const LeadStatusLabel = {
    [LeadStatus.DRAFT_SAVED]: 'Draft Saved',
    [LeadStatus.LEAD_GENERATED]: 'Lead Generated',
    [LeadStatus.PAYMENT_DONE]: 'Payment Done',
    [LeadStatus.PAYMENT_INITIATED]: 'Payment Initiated',
    [LeadStatus.QUOTE_DOWNLOADED]: 'Quote Downloaded',
    [LeadStatus.QUOTE_SHARED]: 'Quote Shared',
    [LeadStatus.QUOTE_FAILED_ICR]: 'Quote Failed (ICR)'
};
export const SortByLeadsLabels = {
    [SORTBYLEADS.DES_DATE]: 'Date (Latest Created)',
    [SORTBYLEADS.ASC_DATE]: 'Date (Oldest Created)'
};
export var QuoteType;
(function (QuoteType) {
    QuoteType["BASE"] = "base";
    QuoteType["MATERNITY"] = "maternity";
    QuoteType["CUSTOMIZED"] = "customized";
})(QuoteType || (QuoteType = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["claimPdf"] = "claimPdf";
    DocumentType["claimDump"] = "claimDump";
})(DocumentType || (DocumentType = {}));
export const DocumentTypeLabel = {
    [DocumentType.claimDump]: 'Claim Dump/PDF',
    [DocumentType.claimPdf]: 'Additional Document'
};
